export default "__VITE_ASSET__DL$7puc7__"